// @ts-nocheck
import React, { useMemo } from 'react';
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Autocomplete,
  TextField,
  Box,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import moment from 'moment-timezone';

type TimezoneSelectProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

const TimezoneSelect: React.FC<TimezoneSelectProps> = ({ value, onChange, disabled }) => {
  const formattedTimeZones: { label: string; value: string }[] = useMemo(() => {
    const timeZones = moment.tz.names();

    return timeZones.map((tz) => {
      const offset = moment.tz(tz).format('Z');
      return { label: `${tz.replace(/_/g, ' ')} (UTC${offset})`, value: tz };
    });
  }, []);

  const selectedOption = formattedTimeZones.find((option) => option.value === value) || null;

  return (
    <FormControl style={{ width: '400px' }} size="small">
      <Autocomplete
        id="timezone-autocomplete"
        options={formattedTimeZones}
        getOptionLabel={(option) => option.label}
        value={selectedOption}
        disabled={disabled}
        onChange={(_, newValue) => onChange(newValue?.value || '')}
        renderInput={(params) => (
          <TextField {...params} disabled={disabled} size="small" label="Timezone" />
        )}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <LocationOnIcon fontSize="small" style={{ marginRight: 8 }} />
            {option.label}
          </Box>
        )}
        isOptionEqualToValue={(option, val) => option.value === val.value}
      />
    </FormControl>
  );
};

export default TimezoneSelect;
